// @ts-nocheck
import { encodeJson as encodeJson_1, decodeJson as decodeJson_1, encodeBinary as encodeBinary_1, decodeBinary as decodeBinary_1, } from "../StatusValue";
import { encodeJson as encodeJson_2, decodeJson as decodeJson_2, encodeBinary as encodeBinary_2, decodeBinary as decodeBinary_2, } from "../(StatusDetail)/WithdrawReason";
import { WireType, } from "../../../../../runtime/wire/index";
import { default as serialize, } from "../../../../../runtime/wire/serialize";
import { encodeBinary as encodeBinary_3, decodeBinary as decodeBinary_3, } from "../../../../google/protobuf/StringValue";
import { default as deserialize, } from "../../../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        status: undefined,
        withdrawReason: undefined,
        blockedReason: undefined,
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    if (value.status !== undefined)
        result.status = encodeJson_1(value.status);
    if (value.withdrawReason !== undefined)
        result.withdrawReason = encodeJson_2(value.withdrawReason);
    if (value.blockedReason !== undefined)
        result.blockedReason = value.blockedReason;
    return result;
}
export function decodeJson(value) {
    const result = getDefaultValue();
    if (value.status !== undefined)
        result.status = decodeJson_1(value.status);
    if (value.withdrawReason !== undefined)
        result.withdrawReason = decodeJson_2(value.withdrawReason);
    if (value.blockedReason !== undefined)
        result.blockedReason = value.blockedReason;
    return result;
}
export function encodeBinary(value) {
    const result = [];
    if (value.status !== undefined) {
        const tsValue = value.status;
        result.push([1, { type: WireType.LengthDelimited, value: encodeBinary_1(tsValue) }]);
    }
    if (value.withdrawReason !== undefined) {
        const tsValue = value.withdrawReason;
        result.push([2, { type: WireType.LengthDelimited, value: encodeBinary_2(tsValue) }]);
    }
    if (value.blockedReason !== undefined) {
        const tsValue = value.blockedReason;
        result.push([3, ((tsValue) => ({ type: WireType.LengthDelimited, value: encodeBinary_3(tsValue) }))({ value: tsValue })]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    var _a;
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    field: {
        const wireValue = wireFields.get(1);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.LengthDelimited ? decodeBinary_1(wireValue.value) : undefined;
        if (value === undefined)
            break field;
        result.status = value;
    }
    field: {
        const wireValue = wireFields.get(2);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.LengthDelimited ? decodeBinary_2(wireValue.value) : undefined;
        if (value === undefined)
            break field;
        result.withdrawReason = value;
    }
    field: {
        const wireValue = wireFields.get(3);
        if (wireValue === undefined)
            break field;
        const value = (_a = (wireValue.type === WireType.LengthDelimited ? decodeBinary_3(wireValue.value) : undefined)) === null || _a === void 0 ? void 0 : _a.value;
        if (value === undefined)
            break field;
        result.blockedReason = value;
    }
    return result;
}
